export function checkRequiredInvalid(model, isSubmitted) {
    if (!isSubmitted) {
        return false;
    }
    const hasError = !model.value || (!!model.value.trim && !model.value.trim());
    model.errors['required'] = hasError;
    return hasError;
}
